export const CREATE_POWER_LEVEL_SUCCESS = 'CREATE_POWER_LEVEL_SUCCESS';
export const CREATE_POWER_LEVEL = 'CREATE_POWER_LEVEL';
export const DELETE_POWER_LEVEL_SUCCESS = 'DELETE_POWER_LEVEL_SUCCESS';
export const DELETE_POWER_LEVEL = 'DELETE_POWER_LEVEL';
export const UPDATE_POWER_LEVEL_SUCCESS = 'UPDATE_POWER_LEVEL_SUCCESS';
export const UPDATE_POWER_LEVEL = 'UPDATE_POWER_LEVEL';
export const POWER_LEVEL_REQUEST = 'POWER_LEVEL_REQUEST';
export const POWER_LEVEL_ERROR = 'POWER_LEVEL_ERROR';
export const POWER_LEVEL_SUCCESS = 'POWER_LEVEL_SUCCESS';
